import React from 'react';
import { Card, CardActionArea, CardContent, Typography, Chip, Stack, Box } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import dayjs from 'dayjs';

import { typeMeta, priorityMeta } from './ticketConstants';

const TicketCard = ({ ticket, onClick }) => {
  const t = typeMeta(ticket.type);
  const p = priorityMeta(ticket.priority);

  return (
    <Card variant="outlined" sx={{ mb: 1, borderLeft: 4, borderLeftColor: `${p.color}.main` }}>
      <CardActionArea onClick={() => onClick(ticket)}>
        <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
          <Stack direction="row" alignItems="center" spacing={0.5} mb={0.5}>
            <Box component="span" sx={{ fontSize: 16 }}>{t.emoji}</Box>
            <Typography variant="caption" color="text.secondary">
              #{ticket.id}
            </Typography>
            <Box flexGrow={1} />
            <Chip size="small" label={p.label} color={p.color} variant="outlined" />
          </Stack>
          <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
            {ticket.title}
          </Typography>
          <Stack direction="row" spacing={1.5} alignItems="center">
            {ticket.comment_count > 0 && (
              <Stack direction="row" spacing={0.3} alignItems="center">
                <ChatBubbleOutlineIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                <Typography variant="caption" color="text.secondary">
                  {ticket.comment_count}
                </Typography>
              </Stack>
            )}
            {ticket.image_count > 0 && (
              <Stack direction="row" spacing={0.3} alignItems="center">
                <ImageOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                <Typography variant="caption" color="text.secondary">
                  {ticket.image_count}
                </Typography>
              </Stack>
            )}
            <Box flexGrow={1} />
            <Typography variant="caption" color="text.secondary">
              {ticket.created_at ? dayjs(ticket.created_at).format('DD/MM') : ''}
            </Typography>
          </Stack>
          <Typography variant="caption" color="text.secondary">
            {ticket.creator_name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default TicketCard;
